export function getApiErrorMessage(error, fallback) {
  const status =
    error && error.response ? Number(error.response.status) || 0 : 0;
  const data =
    error && error.response && error.response.data
      ? error.response.data
      : null;
  const message = data && typeof data.msg === "string" ? data.msg.trim() : "";

  if (status === 401) {
    return "Sesi Anda telah berakhir. Silakan masuk kembali.";
  }

  if (status === 403) {
    return "Akun Anda tidak memiliki akses untuk tindakan ini.";
  }

  if (status === 404) {
    return "Data yang Anda cari tidak ditemukan.";
  }

  if (status >= 500) {
    return fallback;
  }

  if (message && !isUnsafeMessage(message)) {
    return message;
  }

  return fallback;
}

export function getHttpStatus(error) {
  return error && error.response
    ? Number(error.response.status) || 0
    : 0;
}

function isUnsafeMessage(message) {
  const lower = String(message || "").toLowerCase();
  return (
    lower.indexOf("sql") !== -1 ||
    lower.indexOf("select ") !== -1 ||
    lower.indexOf("table ") !== -1 ||
    lower.indexOf("column") !== -1 ||
    lower.indexOf("panic") !== -1 ||
    lower.indexOf("stack trace") !== -1
  );
}



// WEBPACK FOOTER //
// ./src/utils/redesignErrors.js